/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpResponse
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';

import { ResponseB4AListSubscriptionTypePrice } from '../model/responseB4AListSubscriptionTypePrice';
import { ResponseB4AString } from '../model/responseB4AString';
import { ResponseB4ASubscriptionTypePrice } from '../model/responseB4ASubscriptionTypePrice';
import { SubscriptionTypePrice } from '../model/subscriptionTypePrice';

import { Configuration } from '../configuration';
import { BASE_PATH } from '../variables';

@Injectable()
export class SubscriptionTypePriceControllerService {
  public configuration = new Configuration();

  public defaultHeaders = new HttpHeaders();
  protected basePath = 'http://localhost:8080';
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createSubscriptionTypePrice(
    body: SubscriptionTypePrice,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4ASubscriptionTypePrice>;
  public createSubscriptionTypePrice(
    body: SubscriptionTypePrice,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4ASubscriptionTypePrice>>;
  public createSubscriptionTypePrice(
    body: SubscriptionTypePrice,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4ASubscriptionTypePrice>>;
  public createSubscriptionTypePrice(
    body: SubscriptionTypePrice,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling createSubscriptionTypePrice.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4ASubscriptionTypePrice>(
      'post',
      `${this.basePath}/subscription-type-price`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param subscriptionTypePriceId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSubscriptionTypePrice(
    subscriptionTypePriceId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AString>;
  public deleteSubscriptionTypePrice(
    subscriptionTypePriceId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AString>>;
  public deleteSubscriptionTypePrice(
    subscriptionTypePriceId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AString>>;
  public deleteSubscriptionTypePrice(
    subscriptionTypePriceId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (
      subscriptionTypePriceId === null ||
      subscriptionTypePriceId === undefined
    ) {
      throw new Error(
        'Required parameter subscriptionTypePriceId was null or undefined when calling deleteSubscriptionTypePrice.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AString>(
      'delete',
      `${this.basePath}/subscription-type-price/${encodeURIComponent(String(subscriptionTypePriceId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param subscriptionTypePriceId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public findSubscriptionTypePriceById(
    subscriptionTypePriceId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4ASubscriptionTypePrice>;
  public findSubscriptionTypePriceById(
    subscriptionTypePriceId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4ASubscriptionTypePrice>>;
  public findSubscriptionTypePriceById(
    subscriptionTypePriceId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4ASubscriptionTypePrice>>;
  public findSubscriptionTypePriceById(
    subscriptionTypePriceId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (
      subscriptionTypePriceId === null ||
      subscriptionTypePriceId === undefined
    ) {
      throw new Error(
        'Required parameter subscriptionTypePriceId was null or undefined when calling findSubscriptionTypePriceById.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4ASubscriptionTypePrice>(
      'get',
      `${this.basePath}/subscription-type-price/id/${encodeURIComponent(String(subscriptionTypePriceId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param subscriptionTypeId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllSubscriptionTypePriceBySubscriptionTypeId(
    subscriptionTypeId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListSubscriptionTypePrice>;
  public getAllSubscriptionTypePriceBySubscriptionTypeId(
    subscriptionTypeId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListSubscriptionTypePrice>>;
  public getAllSubscriptionTypePriceBySubscriptionTypeId(
    subscriptionTypeId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListSubscriptionTypePrice>>;
  public getAllSubscriptionTypePriceBySubscriptionTypeId(
    subscriptionTypeId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (subscriptionTypeId === null || subscriptionTypeId === undefined) {
      throw new Error(
        'Required parameter subscriptionTypeId was null or undefined when calling getAllSubscriptionTypePriceBySubscriptionTypeId.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListSubscriptionTypePrice>(
      'get',
      `${this.basePath}/subscription-type-price/list/${encodeURIComponent(String(subscriptionTypeId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param subscriptionTypePriceId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSubscriptionTypePrice(
    body: SubscriptionTypePrice,
    subscriptionTypePriceId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4ASubscriptionTypePrice>;
  public updateSubscriptionTypePrice(
    body: SubscriptionTypePrice,
    subscriptionTypePriceId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4ASubscriptionTypePrice>>;
  public updateSubscriptionTypePrice(
    body: SubscriptionTypePrice,
    subscriptionTypePriceId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4ASubscriptionTypePrice>>;
  public updateSubscriptionTypePrice(
    body: SubscriptionTypePrice,
    subscriptionTypePriceId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling updateSubscriptionTypePrice.'
      );
    }

    if (
      subscriptionTypePriceId === null ||
      subscriptionTypePriceId === undefined
    ) {
      throw new Error(
        'Required parameter subscriptionTypePriceId was null or undefined when calling updateSubscriptionTypePrice.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4ASubscriptionTypePrice>(
      'put',
      `${this.basePath}/subscription-type-price/${encodeURIComponent(String(subscriptionTypePriceId))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }
}
